export const CURRENT_IN_SEASON_FOOTBALL = '25/26';
export const CURRENT_IN_SEASON_USSPORT = '25';

export const format = (
  seasonYear: number,
  {
    separator = '-',
    singleCivilYear = false,
  }: {
    separator?: string;
    singleCivilYear?: boolean;
  } = {}
) => {
  if (singleCivilYear) return seasonYear.toString();

  const next = (seasonYear + 1).toString().slice(-2);
  return `${seasonYear}${separator}${next}`;
};

export const formatFilter = (season: string) => format(parseInt(season, 10));
